// Network Types
export enum UserRole {
  USER = "user",
  ADMIN = "admin",
}
